"use client";
import React from "react";
import cn from "classnames";

import ArrowUp from "@/public/images/icons/arrow-up-simple.svg";

import scrCSS from "./ScrollTop.module.scss";
import useShowOnScroll from "@/next-src/hooks/useShowOnScroll";
import Image from "next/image";

const ScrollTop = ({}) => {
  const height = typeof window !== "undefined" ? window?.screen?.height : 1500;
  const isShown = useShowOnScroll(height);
  return (
    <div
      className={cn(scrCSS.btnWrapper, {
        [scrCSS.dNone]: !isShown,
      })}
    >
      <button
        className={cn(scrCSS.btn)}
        type="button"
        onClick={() =>
          window?.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
          })
        }
      >
        <Image width={12} height={14} src={ArrowUp} loading="lazy" alt="" />
      </button>
    </div>
  );
};

ScrollTop.propTypes = {};

export default ScrollTop;
